import { ProjectClusterDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProjectClusterActions from './project-cluster.actions';

export const PROJECT_CLUSTER_FEATURE_KEY = 'projectCluster';

export interface ProjectClusterState extends EntityState<ProjectClusterDto> {
  selectedProjectClusterId?: string | number; // which ProjectCluster record has been selected
  loaded: boolean; // has the ProjectCluster list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProjectClusterPartialState {
  readonly [PROJECT_CLUSTER_FEATURE_KEY]: ProjectClusterState;
}

export const projectClusterAdapter: EntityAdapter<ProjectClusterDto> = createEntityAdapter<
  ProjectClusterDto
>({
  selectId: (projectCluster) => projectCluster.id,
  sortComparer: false,
});

export const initialState: ProjectClusterState = projectClusterAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProjectClusterId: null,
  }
);

const projectClusterReducer = createReducer(
  initialState,
  on(ProjectClusterActions.loadProjectCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectClusterActions.loadProjectClusterSuccess,
    (state, { projectCluster }) =>
      projectClusterAdapter.addAll(projectCluster, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectClusterActions.loadProjectClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectClusterActions.addProjectCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectClusterActions.addProjectClusterSuccess,
    (state, { newProjectCluster }) =>
      projectClusterAdapter.addMany(newProjectCluster, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectClusterActions.addProjectClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProjectClusterActions.updateProjectCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectClusterActions.updateProjectClusterSuccess,
    (state, { updateProjectCluster }) =>
      projectClusterAdapter.upsertMany(updateProjectCluster, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectClusterActions.updateProjectClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  // search student

  on(ProjectClusterActions.searchProjectClusterRecord, (state, { query }) => {
    return {
      ...state,
      selectedProjectClusterId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProjectClusterActions.removeProjectCluster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectClusterActions.removeProjectClusterSuccess, (state, { ids }) =>
    projectClusterAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(ProjectClusterActions.removeProjectClusterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(
  state: ProjectClusterState | undefined,
  action: Action
) {
  return projectClusterReducer(state, action);
}
